// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-up-right.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/arrow-up-right'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowUpRightIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
